import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment or use the provided one
const SUPABASE_URL = 'https://ozqkcbcbaablnmgisemk.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im96cWtjYmNiYWFibG5tZ2lzZW1rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU5MDM3OTIsImV4cCI6MjA4MTQ3OTc5Mn0.2USUYP2CBkkEo_oKJZuqILtx0Hw-ep0Cv47czxG17Jk'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase;